/** Values cross the service worker boundary and the preflight signature - keep them stable. */
export enum DocumentationOperationType {
  archive = 'archive',
  restore = 'restore',
}

export interface DocumentationOperationPreflightRequest {
  operationType: DocumentationOperationType;
  documentations: number[];
  directories: number[];
}

export interface SelectedItemBreakdown {
  type: 'directory' | 'file';
  localId: number;
  name: string;
  nestedCount: number;
}

export interface DocumentationOperationPreflightResponse {
  operationType: DocumentationOperationType;
  resolvedDocumentations: number[];
  resolvedDirectories: number[];
  resolvedCount: number;
  signature: string;
  selectedItemsBreakdown: SelectedItemBreakdown[];
}
